import { ISwrConfiguration, useFetch } from 'lib/hooks';
import { ISession } from 'lib/types/session';

export const useSession = (options?: ISwrConfiguration) =>
  useFetch<ISession>('/auth/current', options);
